import React from "react";

const Ico = ({ children, size = 18, ...p }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...p}
  >
    {children}
  </svg>
);

export const IcoDash = (p) => (
  <Ico {...p}>
    <rect x=".7" y="2.55" width="22.71" height="19.61" rx="2.4" ry="2.4" />
    <path d="M5.05,11.43l3.5-3.23c.52-.48,1.3-.55,1.89-.16l1.87,1.22c.73.48,1.7.38,2.32-.24l3.49-3.49" />
    <path d="M7.67,18.94h-2.18v-3.28c0-.27.22-.48.48-.48h1.22c.27,0,.48.22.48.48v3.28Z" />
    <path d="M12.9,18.94h-2.27v-5.02c0-.33.27-.59.59-.59h1.13c.3,0,.55.24.55.55v5.06Z" />
    <path d="M18.12,18.94h-2.17v-7.41c0-.33.26-.59.59-.59h.98c.33,0,.6.27.6.6v7.41Z" />
  </Ico>
);

export const IcoCumul = (p) => (
  <Ico {...p}>
    <path d="M3 3v18h18" />
    <path d="M7 16l4-4 4 2 5-6" />
  </Ico>
);

export const IcoChevL = (p) => (
  <Ico {...p}>
    <polyline points="15 18 9 12 15 6" />
  </Ico>
);

export const IcoChevR = (p) => (
  <Ico {...p}>
    <polyline points="9 18 15 12 9 6" />
  </Ico>
);

export const IcoLogout = (p) => (
  <Ico {...p}>
    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </Ico>
);

export const IcoHelp = (p) => (
  <Ico {...p}>
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </Ico>
);

export const IcoSettings = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.32 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
);

export const IcoUsers = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

export const IcoChantier = (p) => (
  <Ico {...p}>
    <path d="M2 22h20" />
    <path d="M4 22V9l8-5 8 5v13" />
    <path d="M9 22v-6h6v6" />
    <path d="M9 13h6" />
  </Ico>
);

export const IcoDirection = (p) => (
  <Ico {...p}>
    <circle cx="12" cy="12" r="9" />
    <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
  </Ico>
);

export const IcoCommercial = (p) => (
  <Ico {...p}>
    <path d="M20 7h-3V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H4a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z" />
    <path d="M9 7V5h6v2" />
    <path d="M3 13h18" />
  </Ico>
);

export const IcoRH = (p) => (
  <Ico {...p}>
    <path d="M12 2a5 5 0 0 1 5 5v3H7V7a5 5 0 0 1 5-5z" />
    <path d="M5 10h14v2H5z" />
    <path d="M4 22v-3a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v3" />
    <circle cx="12" cy="6.5" r="1" />
  </Ico>
);

export const IcoAlertes = (p) => (
  <Ico {...p}>
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </Ico>
);